/*
 * @Author: zhouyx
 * @Date: 2024-06-04 10:20:05
 * @LastEditTime: 2024-07-03 10:17:09
 * @LastEditors: zhouyx
 * @FilePath: \长春市民卡h5-s\src\router\largeWithdrawal.js
 * @程序猿: 佛祖保佑     永不宕机     永无BUG
 */
export default [
  {
    path: "/largeWithdrawal",
    component: () => import("@/views/largeWithdrawal/index"),
    children: [
      {
        path: "home",
        component: () => import("@/views/largeWithdrawal/home"),
        meta: {
          title: "银行取款网点查询"
        }
      },
      {
        path: "banklist",
        component: () => import("@/views/largeWithdrawal/bankList"),
        meta: {
          title: "服务网点"
        }
      },
      {
        path: "bankdetail",
        component: () => import("@/views/largeWithdrawal/bankdetail"),
        meta: {
          title: "网点详情"
        }
      },
      {
        path: "loveservice",
        component: () => import("@/views/largeWithdrawal/loveservice"),
        meta: {
          title: "爱心服务"
        }
      },
      {
        path: "calltaxi",
        component: () => import("@/views/largeWithdrawal/calltaxi"),
        meta: {
          title: "一键代驾"
        }
      },
    ]
  }
];



// WEBPACK FOOTER //
// ./src/router/largeWithdrawal.js